/**
 * Asynchronously loads the component for HomePage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';
import styled from 'styled-components';

export const CourseContent = lazyLoad(
  () => import('./index'),
  course => course.CourseContent,
  {
    fallback: <LoadingIndicator />,
  },
);
